<template>
  <v-badge
    bordered
    :offset-x="badgeOffsetX"
    offset-y="8"
    color="grey lighten-4"
    class="mx-2 my-3"
  >
    <template #badge>
      <span
        v-text="order.guests"
        class="black--text"
      />
    </template>
    <v-btn
      depressed
      :rounded="table.type_id == TableType.ROUND"
      :color="color.background"
      :class="color.text"
      class="text-none"
      v-text="table.name"
      @click="clicked()"
      @contextmenu="$emit('more', $event)"
    />
  </v-badge>
</template>

<script>
  import I18n from '@/Mixins/I18n'
  import NeedsPermission from '@/Mixins/NeedsPermission'
  import OrderStatus from '@/Models/Static/OrderStatus'
  import TableType from '@/Models/Static/TableType'

  export default {
    mixins: [
      I18n,
      NeedsPermission,
    ],

    props: {
      table: {
        required: true,
        type: Object,
      },
      order: {
        required: true,
        type: Object,
      },
    },

    data: () => ({
      OrderStatus,
      TableType,
    }),

    computed: {
      badgeOffsetX () {
        const n = this.order.guests
        if (n < 10) return 12
        if (n < 100) return 18
        if (n < 1000) return 25
        if (n < 10000) return 32
        return 38
      },
      isMine () {
        return this.$store.getters['orders/config']('shouldShareOrders')
          || this.order.tenantUser_id == this.$store.state.user.id
      },
      color () {
        // Avoid using strict equality comparisions (or switch statement)
        // because the server may return an stringified number.
        if (! this.isMine) return { background: 'info', text: 'black--text' }
        if (this.order.status == this.OrderStatus.PENDING_NOTE) return { background: 'grey lighten-2', text: 'black--text' }
        if (this.order.status == this.OrderStatus.CHECK_PRINTED) return { background: 'primary', text: 'white--text' }
        return { background: 'warning', text: 'black--text' }
      },
    },

    methods: {
      clicked () {
        // Avoid using strict equality comparisions (or switch statement)
        // because the server may return an stringified number.
        if (this.order.status == this.OrderStatus.PENDING_NOTE) {
          this.edit('catalog')
          return
        }
        if (this.isMine && this.order.status == this.OrderStatus.CHECK_PRINTED && this.can('charge')) {
          this.$store.dispatch('cashControl/getTurn')
            .then(() => this.edit('payment'))
            .catch(e => this.preview())
          return
        }
        this.preview()
      },
      edit (nestedDialog) {
        this.$store.commit('orders/current', this.order)
        if (nestedDialog == 'payment') {
          this.$store.dispatch('orders/payment/reset')
        }
        this.$emit('edit', nestedDialog)
      },
      preview () {
        this.$emit('preview', this.order.id)
      },
    },
  }
</script>
